import React, { useState } from 'react'
import SEO from '../../../common/SEO'
import Layout from '../../../common/Layout'
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne'
import StencilBox from '../../stencils/StencilBox'
import Avatar from 'react-avatar'
import { Accordion } from 'react-bootstrap'
import InterviewQuestionCategoryStencil from './InterviewQuestionCategoryStencil'
import InterviewRelatedSeriesStencil from './InterviewRelatedSeriesStencil'
import AboutAuthorStencil from './AboutAuthorStencil'

function InterviewQuestionsDetailStencil({ tabs, qaList, seriesData }) {
    // Sate variable initialization
    const [activeId, setActiveId] = useState('0');

    // Constant function 
    const CustomToggle = () => {
        return <div
            className="edu-accordion-button bg-white stencil ">
            <StencilBox
                width="100%"
                height="52.16px"
                backgroundColor="#F5F5F5"
            />
        </div>
    }
    return (
        <>
            <SEO title="Top 50 Salesforce Revenue Cloud Interview Questions and Answers (2026 Guide) | Longswitch Academy" url={process.env.PUBLIC_URL + `/interview-questions/salesforce-revenue-cloud-interview-questions`} />
            <Layout searchDisable={true}>

                <section className="edu-course-area eduvibe-home-five-course edu-section-gap">
                    <div className="container">
                        {seriesData?.map((elm, i) => (
                            <div className="row justify-content-between" key={i}>
                                <div className="col-xl-6 col-lg-6">
                                    <div className="w-100 d-flex gap-3 align-items-center">
                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    </div>

                                    <div>
                                        <h1 className="placeholder-glow mb--0">
                                            <span className="placeholder w-100 bg-smoke"></span>
                                        </h1>
                                    </div>

                                    <h3 className="placeholder-glow mb--0">
                                        <span className="placeholder w-100 bg-smoke"></span>
                                    </h3>

                                    <div className="w-100 d-flex gap-3 align-items-center mt--10">
                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    </div>


                                    <div className='row mt--30'>
                                        <div className="col-6 d-flex align-items-center mt--10">
                                            <Avatar className="custom-avatar placeholder placeholder-glow bg-smoke" size={34} round={true} />
                                            <span className="author-title placeholder placeholder-glow h-50 w-50 bg-smoke"></span>
                                        </div>
                                        <div class="col-6 d-none d-sm-flex mt--20">
                                            <div className="w-100 d-flex align-items-center">
                                                <div className="price w-100 h-100 placeholder placeholder-glow bg-smoke"></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-xl-5 col-lg-6">
                                    <div className="relative">
                                        <div className="thumbnail img-height placeholder placeholder-glow bg-smoke mt--10" alt="#" ></div>
                                    </div>
                                    <div class="d-flex d-sm-none mt--20">
                                        <div className="w-100 d-flex align-items-center justify-content-center">
                                            <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <div className="edu-elements-area edu-section-gap bg-color-white interview-questions">
                    <div className="container mb--130">
                        <div className="tabs -side js-tabs">
                            <div className="row y-gap-40">
                                <div className="col-lg-4">
                                    <div className="tabs__controls y-gap-5 js-tabs-controls">
                                        {[0, 1, 2, 3, 4]?.map((elm, i) => (
                                            <h5 className="placeholder-glow mb--0 mt--10">
                                                <span className="placeholder w-100 bg-smoke"></span>
                                            </h5>
                                        ))}

                                    </div>
                                    <div class="edu-blog-widget widget-about bg-white mt--40">
                                        <div class="inner">
                                            <div className="w-100 d-none d-lg-flex gap-3 align-items-center justify-content-between mt--10">
                                                <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                                <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                            </div>
                                            {seriesData?.map((elm, i) => (
                                                <div class="d-none d-lg-block content" key={i}>
                                                    <div class="about-wrapper">
                                                        <div class="about-content mt--10">
                                                            <StencilBox
                                                                width="100%"
                                                                height="100px"
                                                                backgroundColor="#F5F5F5"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <InterviewQuestionCategoryStencil classes="d-none d-lg-block mt--40" />

                                    <InterviewRelatedSeriesStencil classes="d-none d-lg-block mt--40" />

                                    <AboutAuthorStencil classes="d-none d-lg-block mt--40" />
                                </div>

                                <div className="col-lg-8">
                                    {[0, 1, 2, 3, 4, 5]?.map((i) => (
                                        <Accordion bsPrefix="landing-demo-faq edu-accordion-02 variation-2 landing-page-accordion bg-white mb--10" defaultActiveKey="0" flush key={i}>
                                            <Accordion.Item eventKey={i.toString()} key={i} bsPrefix={`edu-accordion-item ${activeId === i.toString() ? 'bg-active' : ''}`}>
                                                <div className="edu-accordion-header">
                                                    <CustomToggle eventKey={i.toString()}>
                                                        <StencilBox
                                                            width="100%"
                                                            height="60px"
                                                            backgroundColor="#F5F5F5"
                                                        />
                                                    </CustomToggle>
                                                </div>
                                                <Accordion.Body bsPrefix="edu-accordion-body"><div>

                                                    <div className="w-100 d-flex gap-3 align-items-center mt--10">
                                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                                        <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                                    </div>

                                                    <h5 className="placeholder-glow mb--0 mt--10">
                                                        <span className="placeholder w-25 bg-smoke"></span>
                                                    </h5>

                                                    <h3 className="placeholder-glow mb--0">
                                                        <span className="placeholder w-100 bg-smoke"></span>
                                                    </h3>

                                                    <h5 className="placeholder-glow mb--0 mt--10">
                                                        <span className="placeholder w-25 bg-smoke"></span>
                                                    </h5>

                                                    <h1 className="placeholder-glow mb--0">
                                                        <span className="placeholder w-100 bg-smoke"></span>
                                                    </h1>

                                                    <h5 className="placeholder-glow mb--0 mt--10">
                                                        <span className="placeholder w-25 bg-smoke"></span>
                                                    </h5>

                                                    <h3 className="placeholder-glow mb--0">
                                                        <span className="placeholder w-100 bg-smoke"></span>
                                                    </h3>
                                                    <div className="w-100 d-flex gap-3 align-items-center mt--10">
                                                        <div className="w-100 d-flex gap-3 align-items-center">
                                                            <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                                            <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                                            <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>

                                                        </div>
                                                        <div className="w-100 d-flex gap-3 align-items-center justify-content-end mt--10">
                                                            <h5 className="price placeholder-glow mb--0">
                                                                <span className="placeholder w-25 h-100 bg-smoke"></span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <StencilBox
                                                        width="100%"
                                                        height="100 px"
                                                        backgroundColor="#F5F5F5"
                                                    />
                                                </div></Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>

                                    ))}
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-12">
                                    <div class="mt--40 ">
                                        <div class="inner">
                                            <div className="w-100 d-flex d-lg-none gap-3 align-items-center justify-content-between mt--10">
                                                <div className="price w-50 h-100 placeholder placeholder-glow"></div>
                                                <div className="price w-25 h-100 placeholder placeholder-glow"></div>
                                            </div>
                                            {seriesData?.map((elm, i) => (
                                                <div class="content d-block d-lg-none" key={i}>
                                                    <div class="about-wrapper">
                                                        <div class="about-content mt--10">
                                                            <StencilBox
                                                                width="100%"
                                                                height="100px"
                                                                backgroundColor="#F5F5F5"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <InterviewQuestionCategoryStencil classes="d-block d-lg-none mt--20" />
                                    <InterviewRelatedSeriesStencil classes="d-block d-lg-none mt--20" />
                                    <AboutAuthorStencil classes="d-block d-lg-none mt--20" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default InterviewQuestionsDetailStencil
